import React, { Component } from 'react';
import { withFormik } from 'formik';
import { compose, find, defaultTo, path, propEq, isEmpty } from 'ramda';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import moment from 'moment';

import { getFileWithKey, toCurrency } from '../../../../../util/helpers';
import image from '../../../../../../images/membership-visual.png';
import styles from './styles.m.scss';

import magic from '../../../../../util/magic';
import { routes } from '../../../../../routes';
import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';
import { apiAddFile } from '../../../../../api/registration';
import { isNilOrEmpty } from '../../../../../util/redux';

import Footer from '../../../../../components/Accordion/Footer';
import FancyRadio from '../../../../../components/Forms/FancyRadio';
import FileBrowser from '../../../../../components/Forms/FileBrowser';
import Checkbox from '../../../../../components/Forms/Checkbox';
import EditField from '../../../../../components/Forms/EditField';

class Membership extends Component {
  updateDocuments = (files) => {
    const { setFieldValue, updateRegistrationMedia } = this.props;
    updateRegistrationMedia(files);
    setFieldValue();
  };

  render() {
    const {
      memberships,
      errors,
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      registration,
      setFieldValue,
      setStep,
      step,
      user,
    } = this.props;
    const isTraining = !isNilOrEmpty(registration.trainingId);
    const proMembership = memberships.find((option) => option.name.toLowerCase().indexOf('professional') !== -1);
    const certMembership = memberships.find((option) => option.name.toLowerCase().indexOf('certification') !== -1);
    const studentMembership = memberships.find((option) => option.name.toLowerCase().indexOf('student') !== -1);
    const emeritusMembership = memberships.find((option) => option.name.toLowerCase().indexOf('emeritus') !== -1);

    const registrations = user.latestRegistrations.filter(
      (r) =>
        r.status != magic.complete &&
        r.status != magic.preRegistration &&
        r.status != magic.registrationApproval &&
        (!r.deadline || moment().diff(moment(r.deadline), 'months') < 0) &&
        r.trainingId == null,
    );

    return (
      <form>
        <img className={cn('mb-5', styles.dividingImg)} src={image} />
        <h2 className={styles.stepHeader}>
          Join a diverse & inclusive network of financial professionals impacting change!
        </h2>
        <p>
          Sage Financial Solutions Membership provides you with a diverse and inclusive professional network, free professional development
          opportunities, and resources and benefits that positively impact your work and enhance your career.
        </p>
        <p>
          <strong>NOTE:</strong> Sage Financial Solutions® membership and certification are completely separate divisions of the
          organization. While membership offers additional benefits to our certified professionals and provides a
          community for them to network and share best practices, membership is not required to hold certification.
          Sage Financial Solutions® Membership dues are nonrefundable.{' '}
          <a href={routes.wordPress.refundPolicy} target="_blank">
            Read Sage Financial Solutions®’s Refund Policy here
          </a>
          .
        </p>
        <p className="dark-blue-heading font-weight-bold">
          * Register for Candidate Membership - same great benefits, lower rate. Membership runs on a calendar year (Jan
          1 – Dec 31).{' '}
          <a href={routes.wordPress.membershipBenefits} target="_blank">
            Learn more &gt;
          </a>
        </p>

        {proMembership && isTraining && registrations.length == 0 && (
          <FancyRadio
            name="membershipId"
            label={`${proMembership.name} (${toCurrency(proMembership.price)})`}
            description={proMembership.description}
            value={proMembership.categoryId}
            checked={values.membershipId}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        )}

        {certMembership && (!isTraining || registrations.length > 0) && (
          <FancyRadio
            name="membershipId"
            label={`${certMembership.name} (${toCurrency(certMembership.price)})`}
            description={certMembership.description}
            value={certMembership.id}
            checked={values.membershipId}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        )}

        {studentMembership && (
          <FancyRadio
            name="membershipId"
            label={`${studentMembership.name} (${toCurrency(studentMembership.price)})`}
            description={studentMembership.description}
            value={studentMembership.id}
            checked={values.membershipId}
            onBlur={handleBlur}
            onChange={handleChange}
          >
            {values.membershipId == studentMembership.id && (
              <div>
                <FileBrowser
                  error={errors.studentMembershipFile}
                  files={registration.media}
                  fileKey={magic.studentMembership}
                  label="Please submit your transcripts"
                  name="studentMembershipFile"
                  addFile={(file) => apiAddFile(registration.id, file)}
                  update={this.updateDocuments}
                />
              </div>
            )}
          </FancyRadio>
        )}

        {emeritusMembership && (
          <FancyRadio
            name="membershipId"
            label={`${emeritusMembership.name} (${toCurrency(emeritusMembership.price)})`}
            description={emeritusMembership.description}
            value={emeritusMembership.id}
            checked={values.membershipId}
            onBlur={handleBlur}
            onChange={handleChange}
          >
            {values.membershipId == emeritusMembership.id && (
              <div>
                <Checkbox
                  name="memberForTenYears"
                  checked={values.memberForTenYears}
                  error={errors.memberForTenYears}
                  label="I've been a member for 10 consecutive years"
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                <EditField
                  block
                  name="dateOfBirth"
                  label="Confirm your date of birth"
                  type="date"
                  error={errors.dateOfBirth}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.dateOfBirth}
                />
              </div>
            )}
          </FancyRadio>
        )}

        {!isNilOrEmpty(values.membershipId) && (
          <p>
            * Membership is not the same as annual certification fees. To pay your annual certification fee, please
            click <Link to={routes.certificationsAndTraining.certifications.pay}>here</Link>.
          </p>
        )}

        <Footer
          step={step}
          setStep={setStep}
          isValid={isValid}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          skipBtn={
            <button
              type="button"
              className="btn btn-secondary mx-3"
              onClick={() => {
                Promise.resolve(setFieldValue('membershipId', 0, false)).then(handleSubmit);
              }}
            >
              No thank you
            </button>
          }
        />
      </form>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration({ ...data, memberships: defaultTo([], data.memberships) }))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration, user }) => ({
    membershipId: defaultTo('', path(['memberships', 0, 'productId'], registration)),
    studentMembershipFile: '',
    memberForTenYears: false,
    dateOfBirth: defaultTo(new Date().toISOString().substr(0, 10), user.dateOfBirth),
  }),
  validate: (values, props) => {
    const { memberships, registration } = props;
    const errors = {};
    const selectedMembershipName = compose(
      defaultTo(''),
      path(['name']),
      find(propEq('id', Number(values.membershipId))),
    )(memberships);
    const isEmeritus = selectedMembershipName.toLowerCase().indexOf('emeritus') !== -1;
    const isStudent = selectedMembershipName.toLowerCase().indexOf('student') !== -1;

    if (isNilOrEmpty(values.membershipId)) {
      errors.membershipId = 'You must pick a membership option';
    } else if (isEmeritus) {
      if (moment().diff(values.dateOfBirth, 'years') < 65) {
        errors.dateOfBirth = 'You must be 65 or older to qualify for this membership';
      }

      if (!values.memberForTenYears) {
        errors.memberForTenYears = 'You must be a member for 10 consecutive years to qualify for this membership';
      }
    } else if (isStudent && !getFileWithKey(registration.media, magic.studentMembership)) {
      errors.studentMembershipFile = 'Required';
    }

    return errors;
  },
  isInitialValid: ({ initialValues, validate }) => isEmpty(validate(initialValues)),
  validateOnChange: true,
})(Membership);
